import {useEffect, useRef} from 'react';

export const useChangeEffect = (value, hasChanged, onChange) => {
    const ref = useRef();
    useEffect(() => {
        hasChanged(value, ref.current) && onChange(value);
        ref.current = value;
    }, [hasChanged, onChange, value]);
};